module.exports = __webpack_public_path__ + "static/media/ipca.5966a976.jpg";